import { SearchOutlined } from "@ant-design/icons";
import { Input, Typography } from "antd";
import { useId } from "react";

import EmptyGif from "@/assets/images/empty-markets.gif";
import BaseButton from "@/components/BaseButton";
import FlexContainer from "@/components/FlexContainer";
import Header from "@/components/Header";
import { MainContainer } from "@/components/Layout/Styled";
import { Loading } from "@/components/Loading";
import Meta from "@/components/Meta";
import AddMarketConfirmModal from "@/components/Modals/AddMarketConfirm";
import { WEEKDAY_OPTIONS_WITH_ALL } from "@/constants/ui/weekdays";
import {
    StyledUMControlsWrapper,
    StyledUMEmptyMarketGif,
    StyledUMRadioGroup,
    StyledUMSearchWrapper,
} from "@/pages/WorkPlan/Tasks/UnplannedMarkets/Styled";

import { MarketSort } from "../../components/MarketSort";
import { StyledCartBtnContainer } from "../SalePage/components/ProductsFormCatalog/ProductsFormCatalog.styled";
import { MarketList } from "./components/MarketList";
import { useUnplannedMarkets } from "./hooks/useUnplannedMarkets";

const UnplannedMarkets = () => {
    const modalId = useId();
    const {
        filteredMarkets,
        selectedDay,
        setSelectedDay,
        searchTerm,
        setSearchTerm,
        selectedMarkets,
        toggleMarketSelection,
        openModal,
        setOpenModal,
        marketExtraIds,
        loading,
    } = useUnplannedMarkets();

    const hasSelectedItems = selectedMarkets.length > 0;

    const handleConfirm = () => {
        if (hasSelectedItems) {
            setOpenModal(true);
        }
    };

    return (
        <>
            <Meta title="Work Plan" />
            <Header
                title="Додати ТТ"
                back
                needConfirm={hasSelectedItems}
                confirmText="У вас є обрані ТТ які ви ще не додали в поточний маршрут, ви впевнені що хочете вийти?"
            />

            {loading && <Loading />}

            <AddMarketConfirmModal
                modalKey={modalId}
                open={openModal}
                setOpenAddMarketModal={setOpenModal}
                marketExtraIds={marketExtraIds}
                selectedMarkets={selectedMarkets}
            />

            <MainContainer>
                <StyledUMControlsWrapper>
                    <StyledUMSearchWrapper>
                        <Input
                            placeholder="Введіть назву"
                            value={searchTerm}
                            size="large"
                            onChange={(e) => setSearchTerm(e.target.value)}
                            addonAfter={<SearchOutlined />}
                            allowClear
                        />
                    </StyledUMSearchWrapper>

                    <MarketSort />
                </StyledUMControlsWrapper>

                <StyledUMRadioGroup
                    options={WEEKDAY_OPTIONS_WITH_ALL}
                    onChange={(e) => setSelectedDay(e.target.value)}
                    value={selectedDay}
                    optionType="button"
                />

                <FlexContainer flexDirection="column" width="100%">
                    {filteredMarkets.length === 0 ? (
                        <>
                            <Typography
                                style={{
                                    textAlign: "center",
                                    padding: "16px 0",
                                }}
                            >
                                За даними парметрами позапланової торгової точки
                                не знайдено
                            </Typography>
                            <FlexContainer justifyContent="center">
                                <StyledUMEmptyMarketGif
                                    src={EmptyGif}
                                    alt="empty markets"
                                />
                            </FlexContainer>
                        </>
                    ) : (
                        <MarketList
                            markets={filteredMarkets}
                            selectedMarkets={selectedMarkets}
                            onToggleSelection={toggleMarketSelection}
                            marketExtraIds={marketExtraIds}
                        />
                    )}
                </FlexContainer>

                <StyledCartBtnContainer>
                    <BaseButton
                        type="primary"
                        disabled={selectedMarkets.length === 0}
                        onClick={handleConfirm}
                    >
                        Підтвердити ({selectedMarkets.length})
                    </BaseButton>
                </StyledCartBtnContainer>
            </MainContainer>
        </>
    );
};

export default UnplannedMarkets;
